export default __webpack_public_path__ + "static/artifakt-element-regular-f2724873edf6ced18bb5de487e501dfe.svg";